import React from 'react';
import { Badge, Tooltip, Loader } from '@mantine/core';
import { useServerStatusContext } from '../contexts/ServerStatusContext';

/**
 * Server Status Component
 * Displays the current connection status with the game server
 */
const ServerStatus: React.FC = () => {
  const { online, loading } = useServerStatusContext();
  
  return (
    <Tooltip
      label={online ? 'Game server is online' : 'Game server is offline'}
      position="bottom"
      withArrow
    >
      <div className="flex items-center">
        <span className="text-sm font-medium">GameServer:</span>
        {loading ? (
          <Loader size="xs" style={{ marginLeft: '8px' }} />
        ) : (
          <Badge
            color={online ? 'green' : 'red'}
            variant="filled"
            size="sm"
            className="px-2 py-1"
            style={{ marginLeft: '8px' }}
          >
            {online ? 'Online' : 'Offline'}
          </Badge>
        )}
      </div>
    </Tooltip>
  );
};

export default ServerStatus; 